import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const IndentOut = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99967 4.16675C4.99967 3.89061 5.22353 3.66675 5.49967 3.66675H12.833C13.1091 3.66675 13.333 3.89061 13.333 4.16675C13.333 4.44289 13.1091 4.66675 12.833 4.66675H5.49967C5.22353 4.66675 4.99967 4.44289 4.99967 4.16675ZM6.51989 6.47986C6.71516 6.67512 6.71516 6.99171 6.51989 7.18697L5.54011 8.16675L6.51989 9.14653C6.71516 9.34179 6.71516 9.65837 6.51989 9.85363C6.32463 10.0489 6.00805 10.0489 5.81279 9.85363L4.47945 8.5203C4.28419 8.32504 4.28419 8.00846 4.47945 7.81319L5.81279 6.47986C6.00805 6.2846 6.32463 6.2846 6.51989 6.47986ZM8.833 6.33341C8.55686 6.33341 8.333 6.55727 8.333 6.83341C8.333 7.10956 8.55686 7.33341 8.833 7.33341H12.833C13.1091 7.33341 13.333 7.10956 13.333 6.83341C13.333 6.55727 13.1091 6.33341 12.833 6.33341H8.833ZM8.333 9.50008C8.333 9.22394 8.55686 9.00008 8.833 9.00008H12.833C13.1091 9.00008 13.333 9.22394 13.333 9.50008C13.333 9.77622 13.1091 10.0001 12.833 10.0001H8.833C8.55686 10.0001 8.333 9.77622 8.333 9.50008ZM5.49967 11.6667C5.22353 11.6667 4.99967 11.8906 4.99967 12.1667C4.99967 12.4429 5.22353 12.6667 5.49967 12.6667H12.833C13.1091 12.6667 13.333 12.4429 13.333 12.1667C13.333 11.8906 13.1091 11.6667 12.833 11.6667H5.49967Z"
        fill={color}
      />
    </svg>
  )
})

export default IndentOut
